import { Plugin } from "@nuxt/types"

const plugin: Plugin = async ({ store }, _inject) => {
  await store.dispatch("nuxtClientInit")
}

export default plugin
